var map = {
	"./Carte.png": "DB3q",
	"./DISA-bird.jpeg": "q+5C",
	"./Felouque.png": "x6uZ",
	"./Tartane.png": "NLJS",
	"./allège.png": "mI59",
	"./ancre-bleu-247x300.jpg": "U4h+",
	"./ancre-bleu-25x30.jpg": "F4xx",
	"./barque.png": "1JAO",
	"./baseline-home-24px.svg": "WAKk",
	"./bg_stripe.png": "T4ES",
	"./bombarque.png": "vFJu",
	"./brigantin.png": "eYhJ",
	"./chasse-marée.png": "c5EB",
	"./chebec.png": "wXHe",
	"./cnrs.png": "sotD",
	"./corvette.png": "Hamk",
	"./frégate.png": "BVCK",
	"./félouque.png": "sGvC",
	"./goeltte.png": "VIea",
	"./label-ANR-bleu-CMJN.png": "3/eV",
	"./lienss.png": "9LS3",
	"./logo_portic_petit.png": "hPaa",
	"./pinque.png": "uDmd",
	"./polacre.png": "Qs5k",
	"./portic_logo_300dpi.png": "nnTG",
	"./schooner.png": "g8zS",
	"./ship.png": "ogU7",
	"./sloop.png": "8k5U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dgrA";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img ^\.\/.*$
// module id = dgrA
// module chunks = 1